<!--
 * @Description:
 * @Author: mdb
 * @Date: 2022-09-16 09:03:53
 * @LastEditTime: 2023-05-05 14:27:12
 * @LastEditors: mdb
-->
<template>
  <a-form ref="formRef" :model="dataForm" autocomplete="off" scrollToFirstError>
    <dc-layout-card :title="props.title" :span="6">
      <dc-form-item label="活动名称" name="activityName" :rules="formRules.input">
        <CosInput
          v-model:value="dataForm.activityName"
          :maxlength="100"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="来源渠道" name="channelId" :rules="formRules.select">
        <ParamCodeCascader
          v-model:value="dataForm.channelId"
          :options="paramCodeData[props.paramCode]"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="活动负责人" name="follower" :rules="formRules.select">
        <UserSelect
          v-model:value="dataForm.follower"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item label="开始结束时间" name="startTime" :rules="formRules.select">
        <CosRangePicker
          v-model:startTime="dataForm.startTime"
          v-model:endTime="dataForm.endTime"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="合作伙伴" name="partnerId">
        <CosSelect
          v-model:value="dataForm.partnerId"
          :fieldNames="{ label: 'name', value: 'id' }"
          :options="partnerEnum"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item label="选择模板" name="activityTemplateId" :rules="formRules.selectNumber">
        <CosSelect
          v-model:value="dataForm.activityTemplateId"
          :fieldNames="{ label: 'name', value: 'id' }"
          :options="templateEnum"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
          @popupScroll="popupScroll"
          allowClear
        />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item label="备注" name="remark" :span="12">
        <CosTextarea
          v-model:value="dataForm.remark"
          :maxlength="2000"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
        />
      </dc-form-item>
    </dc-layout-card>

    <dc-layout-card title="销售名片" :span="24" v-if="props.type === 'view'">
      <a-col>
        <cos-table
          :columns="columns"
          :dataSource="dataForm.businessCardVoList"
          :tableId="props.subdomain === 'fbu' ? 'DcCosFbuActivityCodeViewCardList' : 'DcCosLbuActivityCodeViewCardList'"
          :needPage="false"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'action'">
              <MoreButton>
                <a-button type="link" @click="showModal('zh-CN', record)">中文二维码</a-button>
                <a-button type="link" @click="showModal('en-US', record)">英文二维码</a-button>
              </MoreButton>
            </template>
          </template>
        </cos-table>
      </a-col>

      <a-modal v-model:visible="visible" :title="qrCodeTitle" @ok="handleOk">
        <template #footer>
          <a-button key="submit" type="primary" @click="handleCopy">复制链接</a-button>
          <a-button key="submit" type="primary" @click="handleOk">下载二维码</a-button>
        </template>
        <vue-qr
          :margin="0"
          :size="400"
          :text="qrCodeUrl"
          :logoSrc="qrCodeLogoEnum[props.subdomain]"
          :logoScale="0.25"
          :logoMargin="6"
          :correctLevel="0"
          ref="qrCodeRef"
        />
      </a-modal>
    </dc-layout-card>
  </a-form>

  <cos-footer-button
    v-model:value="dataForm"
    :formRef="formRef"
    :resetValue="initForm"
    :loading="loading"
    :disabled="props.type === 'view'"
    :permissionPage="permissionPage"
    :editUrl="`/${props.subdomain}/activityCode/edit?id=${queryId}`"
    @submit="onSubmit"
  />
</template>

<script setup lang="ts">
import { ref, reactive, toRaw, computed, onBeforeMount, watchEffect, unref } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import { goBack } from '@/hooks/cosRouter'
import { message } from '@dc-platform/dc-components'
import { selectForNumberValidate } from '@/utils/validate'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { listByParamCodes } from '@/api/common'
import { ActivityCodeEditParams } from '@/typings/api/marketingManage'
import {
  activityCreate,
  activityUpdate,
  activityDetail,
  partnerDropList,
  templateList
} from '@/api/marketing/marketingManage'
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard'
import { paramCodesDataFilter, downloadFileByBase64 } from '@/utils/index'
import type { FormInstance } from 'ant-design-vue'
import type { ParamCodeItem } from '@/typings/common'
const { clipboardRef, copiedRef } = useCopyToClipboard()

const props = defineProps<{
  type: 'add' | 'edit' | 'view'
  subdomain: 'fbu' | 'lbu'
  title: string
  paramCode: string
}>()
watchEffect(() => {
  if (props.type === 'view' && props.subdomain == null) {
    console.error('当详情页时, props subdomain 必传')
  }
})
const columns = ref([
  { title: '销售员', dataIndex: 'followerName' },
  { title: '操作', dataIndex: 'action', width: 170 }
])

const permissionPage = computed(() => {
  const addPermissions = {
    fbu: { save: 'fbu_activity_add_btn' },
    lbu: { save: 'lbu_activity_add_btn' }
  }
  const otherPermissions = {
    fbu: { edit: 'fbu_activity_edit_btn', save: 'fbu_activity_edit_btn' },
    lbu: { edit: 'lbu_activity_edit_btn', save: 'lbu_activity_edit_btn' }
  }
  return props.type === 'add' ? addPermissions[props.subdomain] : otherPermissions[props.subdomain]
})
const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  [props.paramCode]: [] // 来源渠道
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: [props.paramCode]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    paramCodeData.value = res.data
  })
}
const partnerEnum = ref()
const getPartner = () => {
  partnerDropList().then((res) => {
    partnerEnum.value = res.data
  })
}
const templateEnum = ref<any[]>([])
const pageUtils = reactive({ pageNumber: 1, pageSize: 100 })
const getTemplate = () => {
  templateList(pageUtils).then((res) => {
    templateEnum.value = [...templateEnum.value, ...res.data.items]
  })
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageUtils.pageNumber = pageUtils.pageNumber + 1
    getTemplate()
  }
}
onBeforeMount(() => {
  getByParamCodes()
  getPartner()
  getTemplate()
})

const loading = ref(false)
const formRef = ref<FormInstance>()
const queryId = computed(() => route.query.id as string)
const initForm = reactive<ActivityCodeEditParams>({
  activityName: undefined,
  channelId: undefined,
  follower: undefined,
  startTime: undefined,
  endTime: undefined,
  partnerId: undefined,
  activityTemplateId: undefined,
  remark: undefined
})
const dataForm = reactive<ActivityCodeEditParams>(cloneDeep(initForm))
const formRules = reactive({
  input: [{ required: true, message: '请输入' }],
  select: [{ required: true, message: '请选择' }],
  selectNumber: [{ required: true, validator: selectForNumberValidate }]
})

const route = useRoute()
const getDetails = () => {
  loading.value = true
  activityDetail({ activityQrcodeId: route.query.id as string })
    .then((res) => {
      if (props.type === 'edit') {
        res.data.activityQrcodeId = res.data.id
      }
      Object.assign(initForm, res.data)
      Object.assign(dataForm, res.data)
    })
    .finally(() => {
      loading.value = false
    })
}
onBeforeMount(() => {
  if (props.type !== 'add') {
    getDetails()
  }
})

const handleSubmitAdd = () => {
  loading.value = true
  activityCreate(toRaw(dataForm))
    .then(() => {
      message.success('新增活码成功')
      goBack()
    })
    .finally(() => {
      loading.value = false
    })
}
const handleSubmitEdit = () => {
  loading.value = true
  activityUpdate(toRaw(dataForm))
    .then(() => {
      message.success('修改活码成功')
      goBack()
    })
    .finally(() => {
      loading.value = false
    })
}

const onSubmit = () => {
  if (props.type === 'add') {
    handleSubmitAdd()
  } else if (props.type === 'edit') {
    handleSubmitEdit()
  }
}

const qrCodeRef = ref()
const qrCodeTitle = ref('')
const visible = ref<boolean>(false)
const currentRow = ref()
const qrCodeType = ref<'zh-CN' | 'en-US'>()
const qrCodeUrl = ref('')
const qrCodeLogoEnum = {
  fbu: require('@/assets/logo_gucang.png'),
  lbu: require('@/assets/logo_yuntu.png')
}
const handleCopy = () => {
  clipboardRef.value = qrCodeUrl.value
  if (unref(copiedRef)) {
    message.success('复制成功')
  } else {
    message.error('该浏览器不支持自动复制!')
  }
}
const showModal = (lang: 'zh-CN' | 'en-US', row: any) => {
  const langEnum = { 'zh-CN': '中文二维码', 'en-US': '英文二维码' }
  qrCodeType.value = lang
  qrCodeTitle.value = langEnum[lang]
  currentRow.value = row
  qrCodeUrl.value = `${window.WEB_URL}/mobile.html#/businessCard?cardId=${row.id}&follower=${row.follower}&subdomain=${props.subdomain}&lang=${qrCodeType.value}`
  visible.value = true
}
const handleOk = () => {
  downloadFileByBase64(qrCodeRef.value.imgUrl, `${currentRow.value?.followerName}-${qrCodeType.value}`)
  visible.value = false
}
</script>
<script lang="ts">
export default { name: 'DetailForm' }
</script>

<style scoped></style>
